import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    adminInfo: JSON.parse(localStorage.getItem('admin_info') || 'null'),
    token: localStorage.getItem('admin_token') || ''
  },
  
  mutations: {
    SET_ADMIN_INFO(state, adminInfo) {
      state.adminInfo = adminInfo
      localStorage.setItem('admin_info', JSON.stringify(adminInfo))
    },
    
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('admin_token', token)
    },
    
    CLEAR_ALL(state) {
      state.adminInfo = null
      state.token = ''
      localStorage.removeItem('admin_info')
      localStorage.removeItem('admin_token')
    }
  },
  
  actions: {
    login({ commit }, data) {
      commit('SET_TOKEN', data.token)
      commit('SET_ADMIN_INFO', data.adminInfo)
    },
    
    logout({ commit }) {
      commit('CLEAR_ALL')
    }
  },
  
  getters: {
    isLogin: state => !!state.token,
    adminInfo: state => state.adminInfo
  }
})
